module.exports = __webpack_public_path__ + "img/issues-close.ab0dcd1f.svg";